/*
 * Maison Faubourg Paris — galerie de la fiche produit, mobile uniquement.
 * Même principe que la section « Univers du remontoir » : toutes les photos sont empilées dans UN cadre fixe, et la photo suivante
 * se dévoile par-dessus la précédente, son bord gauche suivant le doigt. Rien ne bouge dans le cadre : pas de liseré ni de flash.
 * Le geste et les crans restent ceux du thème (doigt de droite à gauche, photo par photo) : la galerie du thème défile toujours,
 * mais ses photos sont invisibles ; ce sont les copies empilées qui s'affichent.
 *
 * Le dévoilement est une animation CSS pilotée par le défilement (voir assets/maison-faubourg.css, blocs « mf-gal- »).
 * Ce script construit le cadre fixe et donne à chaque photo ses repères. Sur un navigateur qui ne sait pas faire ces animations,
 * rien n'est activé : la galerie reste celle du thème.
 *
 * Pour tout retirer : supprimer ce fichier, la ligne qui le charge dans snippets/scripts.liquid et le bloc « mf-gal- » du CSS.
 */
(function () {
  if (window.mfGalleryReveal) return;
  window.mfGalleryReveal = true;

  if (!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()'))) return;

  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function enabled() { return !!mq.matches && !reduceMq.matches; }

  function slidesOf(scroller) {
    var list = [];
    for (var i = 0; i < scroller.children.length; i++) {
      var el = scroller.children[i];
      if (el.tagName === 'SLIDESHOW-SLIDE') list.push(el);
    }
    return list;
  }

  function allScrollers() {
    return document.querySelectorAll('media-gallery slideshow-slides');
  }

  function stageOf(scroller) {
    var container = scroller.parentElement;
    if (!container) return null;
    for (var i = 0; i < container.children.length; i++) {
      if (container.children[i].classList.contains('mf-gal-stage')) return container.children[i];
    }
    return null;
  }

  function clear(scroller) {
    var stage = stageOf(scroller);
    if (stage) stage.remove();
    var gallery = scroller.closest('media-gallery');
    if (gallery) gallery.removeAttribute('data-mf-stage');
    scroller.__mfSig = '';
  }

  function build(scroller) {
    var slides = slidesOf(scroller);
    var container = scroller.parentElement;
    var gallery = scroller.closest('media-gallery');
    if (!enabled() || !container || !gallery || slides.length < 2) { clear(scroller); return; }

    // une photo = une image ; s'il y a une vidéo ou un modèle 3D dans la galerie, on laisse la galerie du thème
    var imgs = [];
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].querySelector('video, model-viewer, product-model, iframe')) { clear(scroller); return; }
      var img = slides[i].querySelector('img');
      if (!img) { clear(scroller); return; }
      imgs.push(img);
    }

    var width = scroller.clientWidth;
    var range = scroller.scrollWidth - width; // distance totale de défilement
    if (!width || range <= 0) { clear(scroller); return; }

    var lefts = slides.map(function (s) { return s.offsetLeft; });
    var sig = [width, range, lefts.join(','), imgs.map(function (m) { return m.getAttribute('src'); }).join('|')].join('/');
    if (scroller.__mfSig === sig && stageOf(scroller)) return; // rien n'a changé : on ne reconstruit pas
    scroller.__mfSig = sig;

    var old = stageOf(scroller);
    if (old) old.remove();

    var stage = document.createElement('div');
    stage.className = 'mf-gal-stage';
    stage.setAttribute('aria-hidden', 'true');

    imgs.forEach(function (img, idx) {
      var copy = document.createElement('img');
      copy.src = img.getAttribute('src') || '';
      if (img.getAttribute('srcset')) copy.setAttribute('srcset', img.getAttribute('srcset'));
      if (img.getAttribute('sizes')) copy.setAttribute('sizes', img.getAttribute('sizes'));
      copy.alt = '';
      copy.decoding = 'async';
      copy.loading = 'eager';
      copy.draggable = false;
      if (idx > 0) {
        // la photo se dévoile pendant que le défilement va de (left - largeur) à left
        var r0 = clamp((lefts[idx] - width) / range, 0, 1) * 100;
        var r1 = clamp(lefts[idx] / range, 0, 1) * 100;
        copy.setAttribute('data-mf-wipe', '');
        copy.style.setProperty('--mf-r0', r0.toFixed(3) + '%');
        copy.style.setProperty('--mf-r1', r1.toFixed(3) + '%');
      }
      stage.appendChild(copy);
      if (copy.decode) copy.decode().catch(function () {});
    });

    container.appendChild(stage);
    gallery.setAttribute('data-mf-stage', '');
  }

  function syncAll() {
    var scrollers = allScrollers();
    for (var i = 0; i < scrollers.length; i++) build(scrollers[i]);
  }

  if (mq.addEventListener) mq.addEventListener('change', syncAll);
  if (reduceMq.addEventListener) reduceMq.addEventListener('change', syncAll);
  window.addEventListener('resize', syncAll, { passive: true });
  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('load', syncAll);
  setTimeout(syncAll, 400);
  setTimeout(syncAll, 1500);
  setTimeout(syncAll, 3000);

  // la galerie peut être rechargée (changement de variante) : on reconstruit le cadre pour les nouvelles photos
  if (window.MutationObserver) {
    var timer = 0;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && node.classList && node.classList.contains('mf-gal-stage')) continue;
          if (node.nodeType === 1 && (node.tagName === 'SLIDESHOW-SLIDES' || (node.querySelector && node.querySelector('slideshow-slides')))) {
            clearTimeout(timer);
            timer = setTimeout(syncAll, 120);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
